/* dcl-silca-note.js  (rev 1)
 * Dialed Cycling Lab. Surfaces the Silca gift card offer on Silca product pages.
 *
 * WHY THIS FILE IS NOT OPTIONAL. Google Merchant Center requires that a gift
 * card promotion be stated on the product landing page, and a reviewer loads a
 * cold page with no engagement history. A product covered by the promotion
 * whose page does not state it is a disapproval.
 *
 * ONE STATE, for now. The Lake equivalent has a quiet state and a full state,
 * because the Lake popup does the selling and the quiet line only has to exist
 * for the reviewer. Silca has no popup yet, so this line is the only surface on
 * the page and it renders at full prominence. When the Silca popup ships, add
 * the quiet/full split here the way dcl-shoe-bonus-note.js does it.
 *
 * STATES THE RULE, NOT A TOTAL. The product page does not reliably know the
 * chosen quantity at load, and it never knows what else is in the cart. The
 * cart line (dcl-silca-cart.js) does the arithmetic against the live cart.
 *
 * Gating lives in theme.liquid, which sets window.DCL_SILCA_NOTE.
 */
(function () {
  'use strict';

  if (window.__dclSilcaNote) return;
  window.__dclSilcaNote = true;
  if (!window.DCL_SILCA_NOTE) return;

  var LEAD = 'Spend $150 on Silca and we email you a ';
  var AMOUNT = '$20';
  var TAIL = ' Dialed gift card once your order is placed.';

  var TERMS_HREF = '/pages/silca-gift-card-terms';
  var TERMS_LABEL = 'Terms';

  var ANCHORS = [
    '#MainContent form[action*="/cart/add"]',
    '#MainContent .product-form'
  ];

  function anchor() {
    for (var i = 0; i < ANCHORS.length; i++) {
      var el = document.querySelector(ANCHORS[i]);
      if (el) return el;
    }
    return null;
  }

  /*
   * Same gift glyph as the Lake note and the Silca cart line, so the three
   * surfaces read as one program rather than three separate builds.
   */
  function icon(size) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    ['M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z',
     'M12 8l0 13',
     'M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7',
     'M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5'
    ].forEach(function (d) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }

  function styles() {
    if (document.getElementById('dcl-sn-css')) return;
    var s = document.createElement('style');
    s.id = 'dcl-sn-css';
    s.textContent = [
      '.dcl-sn{width:100%;box-sizing:border-box;font-family:inherit;',
      'display:flex;flex-direction:column;align-items:center;gap:10px;',
      'margin:-.5rem 0 1rem 0;padding:1rem .75rem;text-align:center;',
      'font-size:.9375rem;line-height:1.45;opacity:0;transform:translateY(4px);',
      'transition:opacity .3s ease,transform .3s ease}',
      '.dcl-sn.is-open{opacity:1;transform:none}',
      '.dcl-sn__mark{display:flex;align-items:center;justify-content:center;',
      'flex-shrink:0;width:44px;height:44px;border-radius:50%;',
      'background:#1a1a1a;color:#fff!important}',
      '.dcl-sn__text{display:block;max-width:34ch;font-weight:700}',
      '.dcl-sn__amt{color:#e42e0f!important}',
      '.dcl-sn__terms{color:inherit;text-decoration:underline;',
      'text-underline-offset:2px;white-space:nowrap;font-weight:400}',
      '@media (max-width:749px){.dcl-sn{padding:.9rem .5rem}',
      '.dcl-sn__mark{width:38px;height:38px}}',
      '@media (prefers-reduced-motion:reduce){.dcl-sn{transition:none}}'
    ].join('');
    document.head.appendChild(s);
  }

  function textNode() {
    var txt = document.createElement('span');
    txt.className = 'dcl-sn__text';
    txt.appendChild(document.createTextNode(LEAD));
    var amt = document.createElement('span');
    amt.className = 'dcl-sn__amt';
    amt.textContent = AMOUNT;
    txt.appendChild(amt);
    txt.appendChild(document.createTextNode(TAIL + ' '));
    var terms = document.createElement('a');
    terms.className = 'dcl-sn__terms';
    terms.href = TERMS_HREF;
    terms.textContent = TERMS_LABEL;
    txt.appendChild(terms);
    return txt;
  }

  function build() {
    var note = document.createElement('div');
    note.className = 'dcl-sn';
    note.setAttribute('role', 'status');
    var mark = document.createElement('span');
    mark.className = 'dcl-sn__mark';
    mark.appendChild(icon(22));
    note.appendChild(mark);
    note.appendChild(textNode());
    return note;
  }

  function render() {
    if (document.querySelector('.dcl-sn')) return true;
    var target = anchor();
    if (!target || !target.parentNode) return false;
    styles();
    var note = build();
    target.parentNode.insertBefore(note, target);
    requestAnimationFrame(function () { note.classList.add('is-open'); });
    return true;
  }

  function boot() {
    if (render()) return;
    /*
     * Some product templates build the add to cart form after first paint.
     * Watch briefly rather than giving up, then stop so the observer does not
     * sit on the page for the whole session.
     */
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function () {
      if (render()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
